var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"support",attrs:{"useBanner":false}},[_c('Banner',{attrs:{"data":_vm.info.banner}}),_c('Application',{attrs:{"data":_vm.info.application}}),_c('DevelopCourse',{attrs:{"data":_vm.info.developcourse}}),_c('TrainingVideo',{attrs:{"data":_vm.info.training}}),_c('Bottom',{attrs:{"data":_vm.info.bottom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }